/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';
import type { Transaction } from './Transaction';
import {
    TransactionFromJSON,
    TransactionFromJSONTyped,
    TransactionToJSON,
} from './Transaction';

/**
 * 
 * @export
 * @interface PageableTransactions
 */
export interface PageableTransactions {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof PageableTransactions
     */
    result: Array<Transaction>;
    /**
     * 
     * @type {Page}
     * @memberof PageableTransactions
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableTransactions interface.
 */
export function instanceOfPageableTransactions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableTransactionsFromJSON(json: any): PageableTransactions {
    return PageableTransactionsFromJSONTyped(json, false);
}

export function PageableTransactionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableTransactions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(TransactionFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableTransactionsToJSON(value?: PageableTransactions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(TransactionToJSON)),
        'page': PageToJSON(value.page),
    };
}

